import { DayOfWeek } from "@js-joda/core";
import { PricingByType } from "@/model/enum/PricingByType";
import { MapDeserializer } from "@/util/MapDeserializer";
import PriceAdjustment from "@/model/PriceAdjustment";
export default class PriceStructure {
    id;
    prices = new Map();
    pricingByTypes = [];
    pricedPerNight = false;
    displayPrice;
    discounts = {};
    taxRate;
    priceAdjustments = [];
    isPricingByResources() {
        return this.pricingByTypes.includes(PricingByType.BY_RESOURCE);
    }
    isPricingByFlatrate() {
        return this.pricingByTypes.includes(PricingByType.BY_FLAT_RATE);
    }
    init(other) {
        Object.assign(this, other);
        if (!(other instanceof PriceStructure)) {
            this.prices = new Map();
            const otherPrices = other.prices;
            for (const dayOfWeekName in otherPrices) {
                const dayOfWeekPrices = MapDeserializer.deserializePriceTypeMap(otherPrices[dayOfWeekName]);
                this.prices.set(DayOfWeek.valueOf(dayOfWeekName), dayOfWeekPrices);
            }
            const otherPriceAdjustments = other.priceAdjustments;
            this.priceAdjustments = otherPriceAdjustments.map(priceAdjustment => {
                const newPriceAdjustment = new PriceAdjustment();
                newPriceAdjustment.init(priceAdjustment);
                return newPriceAdjustment;
            });
        }
    }
}
